import { render, staticRenderFns } from "./ReportAbsences.vue?vue&type=template&id=6ccbbf64&scoped=true&"
import script from "./ReportAbsences.vue?vue&type=script&lang=js&"
export * from "./ReportAbsences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbbf64",
  null
  
)

export default component.exports